import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const updateJackpots = createAsyncThunk(
    'jackpots/updateJackpots',
    async (_, { extra, getState, rejectWithValue }) => {
        const { socket } = extra;
        try {
            const { user } = getState();
            if (user.playingGameId !== null || !socket.isConnected) {
                return null;
            }
            const data = await socket.getJackpots();
            return data;
        } catch (err) {
            return rejectWithValue(err.message || `error: ${err}`);
        }
    }
);

export const jackpotsSlice = createSlice({
    name: 'jackpots',
    initialState: {
        bronze: null,
        silver: null,
        gold: null,
        diamond: null,
        showJackpots: false,
        jackpotsReady: false,
    },
    extraReducers: {
        [updateJackpots.fulfilled]: (state, { payload }) => {
            if (!payload) {
                return;
            }
            state.bronze = payload.bronze;
            state.bronzeStart = payload.bronzeFixed;
            state.silver = payload.silver;
            state.silverStart = payload.silverFixed;
            state.gold = payload.gold;
            state.goldStart = payload.goldFixed;
            state.diamond = payload.diamond;
            state.diamondStart = payload.diamondFixed;
            state.showJackpots = !payload.hidden;
            state.jackpotsReady = true;
            return state;
        },
    },
});

export const jackpotsSelector = (state) => state.jackpots;
export default jackpotsSlice.reducer;